<template>
  <p>
    $<span ref="num">{{ newRaised }}</span> raised
  </p>
</template>

<script>
export default {
  props: {
    raised: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      newRaised: 0,
    }
  },
  mounted() {
    this.newRaised = Number(this.raised).toLocaleString()
  },
}
</script>
